import { useState } from 'react';

import { MAX_ZOOM, MIN_ZOOM, ZOOM_STEP } from '../constants';

/** Zoom level of a preview, stepped and clamped to the shared bounds. */
export const useZoom = (initial = 1) => {
  const [zoom, setZoom] = useState(initial);

  return {
    zoom,
    canZoomIn: zoom < MAX_ZOOM,
    canZoomOut: zoom > MIN_ZOOM,
    zoomIn: () => setZoom(z => Math.min(MAX_ZOOM, z + ZOOM_STEP)),
    zoomOut: () => setZoom(z => Math.max(MIN_ZOOM, z - ZOOM_STEP))
  };
};

export type Zoom = ReturnType<typeof useZoom>;
